import axios from "axios";

export default {
    namespaced: true,
    state: {
        payment: null,
        checkout: null
    },
    getters: {
        payment: state => state.payment,
        checkout: state => state.checkout,
    },
    mutations: {
        payment(state, payment) {
            state.payment = payment;
        },
        checkout(state, checkout) {
            state.checkout = checkout;
        }
    },
    actions: {
        checkout({ state }, { order, gateway}) {
            return new Promise((resolve, reject) => {
                axios.post(`/payments/checkout/${gateway}/${order}`).then((response) => {
                    if (response.data.url) {
                        resolve();
                        window.location.href = response.data.url;
                        return;
                    }

                    state.checkout = response.data;
                    resolve(state.checkout);
                }).catch((error) => {
                    reject(error);
                })
            });
        }
    },
}
